import { Button } from '@mui/material'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, TextField } from 'components/Form'
import { PasswordIcon } from 'features/user/components/PasswordIcon'
import { Schema } from './schema'

export const Form = () => {
  const { t } = useTranslation('features/user')
  const {
    control,
    formState: { isValid },
  } = useFormContext<Schema>()
  const [showPassword, setShowPassword] = useState<boolean>(false)

  return (
    <>
      <BoxForm>
        <TextField
          control={control}
          InputProps={{ endAdornment: <PasswordIcon {...{ setShowPassword, showPassword }} /> }}
          label={t('confirmResetPassword.form.password.label')}
          name='password'
          type={showPassword ? 'text' : 'password'}
        />

        <TextField
          control={control}
          InputProps={{ endAdornment: <PasswordIcon {...{ setShowPassword, showPassword }} /> }}
          label={t('confirmResetPassword.form.passwordConfirmation.label')}
          name='passwordConfirmation'
          type={showPassword ? 'text' : 'password'}
        />
      </BoxForm>

      <Button
        data-cy='button-submit-confirn-reset-password-form'
        disabled={!isValid}
        sx={{ mt: 2 }}
        type='submit'
        variant='contained'
      >
        {t('confirmResetPassword.form.button')}
      </Button>
    </>
  )
}
